import React, { FC, ReactNode } from 'react'
import styled from 'particles/themes/styled'
import Icon from 'particles/Icon'
import { LinearProgress } from '@mui/material'

const ProgressBar = styled(LinearProgress)`
    &.MuiLinearProgress-root {
        height: 4px;
    }
    &.MuiLinearProgress-colorPrimary {
        background-color: ${({ theme }): string => theme.colors.divider.primary};
    }
    & .MuiLinearProgress-barColorPrimary {
        background-color: #000000;
    }
`

interface PreviewContainerProps {
    children?: ReactNode
    stepNumber?: number
}

const PreviewContainer: FC<PreviewContainerProps> = ({ children, stepNumber }) => {
    const now = new Date()
    const timeString = `${now.getHours()}:${now.getMinutes()}`
    const progress = stepNumber ? (stepNumber === 0 ? 0 : 100 / stepNumber) : 0
    return (
        <Container>
            <div className="status-bar">
                <div className="time">{timeString}</div>
                <div className="mobile-icon">
                    <Icon size="20px" name={'cellSignalFull'} color={'neutralActionActive'} />
                    <Icon size="20px" name={'wifiHigh'} color={'neutralActionActive'} />
                    <div className="battery-icon">
                        <Icon size="20px" name={'batteryFull'} color={'neutralActionActive'} />
                    </div>
                </div>
            </div>
            {stepNumber && <ProgressBar variant="determinate" value={progress} />}
            {children}
            <div className="footer">
                <div className="home-indicator" />
            </div>
        </Container>
    )
}

const Container = styled.div`
    max-width: 375px;
    min-width: 375px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    border: 1px solid ${({ theme }) => theme.colors.border.primary};

    .status-bar {
        width: 100%;
        height: 44px;
        display: flex;
        justify-content: space-between;
    }
    .time {
        font-family: 'SF Pro Text';
        font-size: 15px;
        font-weight: 600;
        line-height: 17.9px;
        margin-left: 21px;
        margin-top: 13px;
    }
    .mobile-icon {
        margin-top: 10px;
        margin-right: 21px;
        display: flex;
        justify-content: space-between;
        .battery-icon {
            margin-left: 2px;
        }
    }
    .footer {
        width: 100%;
        height: 34px;
        color: ${({ theme }) => theme.colors.surface.primary};
        .home-indicator {
            width: 134px;
            height: 5px;
            margin: 20px auto 0px;
            background: #000000;
            border-radius: 5px;
        }
    }
`

export default PreviewContainer
